var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookIconWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "15px",
    viewBox: "0 0 8 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "facebook_icon_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    transform: "translate(-1114.000000, -1507.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook_icon_white",
    transform: "translate(1114.000000, 1507.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.04924838,14.9793457 L5.04924838,8.1465404 L7.34270571,8.1465404 L7.68611841,5.48367492 L5.04924838,5.48367492 L5.04924838,3.78360356 C5.04924838,3.01264256 5.26333361,2.48725807 6.36888151,2.48725807 L7.77895486,2.48664191 L7.77895486,0.104953664 C7.53508802,0.0725022378 6.6980538,4.79616347e-14 5.7242296,4.79616347e-14 C3.69120726,4.79616347e-14 2.29934519,1.24095898 2.29934519,3.51988437 L2.29934519,5.48367492 L8.8817842e-16,5.48367492 L8.8817842e-16,8.1465404 L2.29934519,8.1465404 L2.29934519,14.9793457 L5.04924838,14.9793457 Z",
    id: "facebook-icon"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIconWhite);
export default __webpack_public_path__ + "static/media/facebook_icon_white.bc86e2125f9eff732b52d219a23ab4d6.svg";
export { ForwardRef as ReactComponent };